<script setup>
import { computed, toRefs } from "vue";

const props = defineProps(["labels", "counts", "percents", "colores"]);

const { labels, counts, percents, colores } = toRefs(props);

const proporcionBarras = computed(() => {
  const maximo = Math.max(...counts.value);
  return counts.value.map((item) => item / maximo);
});
</script>

<template>
  <div class="barras-porcentaje">
    <div class="barra-porcentaje" v-for="(label, idx) in labels" :key="label">
      <label class="barra-porcentaje-nombre">{{ label }}</label>
      <div
        class="barra-porcentaje-avance a11y-simplificada-none"
        :style="{
          width: `calc((100% - 210px) * ${proporcionBarras[idx]})`,
          backgroundColor: colores[idx],
        }"
      />
      <label class="barra-porcentaje-cantidades">
        {{ percents[idx] }}% ({{ counts[idx].toLocaleString() }})
      </label>
    </div>
  </div>
</template>

<style lang="scss">
.barras-porcentaje {
  padding: 16px 0;

  @media (min-width: map-get($media-queries-limit, "mobile")) {
    padding: 42px 0;
  }

  .barra-porcentaje {
    display: flex;
    align-items: center;
    max-width: 710px;
    min-width: 80%;
    gap: 10px;
    margin-left: auto;
    margin-right: auto;

    label {
      font-size: 0.85rem;
    }

    &-nombre {
      text-align: end;
      min-width: 70px;
    }

    &-avance {
      background-color: red;
      height: 1em;
    }

    &-cantidades {
      min-width: 120px;
    }
  }
}

.a11y-simplificada {
  .barras-porcentaje {
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      padding: 16px 0;
    }

    .barra-porcentaje {
      justify-content: center;
    }
  }
}
</style>
